<template>
  <v-container class="ml-6">
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="d-flex justify-center">
        <h2 class="text-h6">Payment</h2>
      </v-card>

      <v-row dense class="mt-2">
        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Application ID
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ applicantData.application_id || "..." }}
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Name
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ applicantData.name || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Email
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ applicantData.email || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Mobile
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{
                applicantData.mobile_prefix && applicantData.mobile_no
                  ? `${applicantData.mobile_prefix} ${applicantData.mobile_no}`
                  : "..."
              }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Programme
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ programName || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Batch
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{
                applicantData.year && applicantData.batch
                  ? `${applicantData.year} - ${applicantData.batch}`
                  : "..."
              }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Selected plan
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ studentPaymentPlan.name || "..." }}
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="2" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              {{
                studentPaymentPlan.plan_amount_balance >= 0
                  ? "Plan Amount to Pay"
                  : "Plan Amount"
              }}
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              ₹{{
                studentPaymentPlan.plan_amount_balance <= 0
                  ? formatAmount(studentPaymentPlan.plan_amount_to_pay)
                  : formatAmount(studentPaymentPlan.plan_amount_balance) ||
                    "..."
              }}
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          class="py-1 px-1"
          v-if="studentPaymentPlan.plan_amount_balance <= 0"
        >
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Amount Paid
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ formatAmount(studentPaymentPlan.plan_amount_paid) || "..." }}
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="studentPaymentPlan.plan_amount_balance > 0">
        <v-row class="mt-6 mx-2">
          <div class="text-subtitle-1 font-weight-medium">Payment Details</div>
        </v-row>
        <v-row ref="loan">
          <v-row class="mt-2 mx-2">
            <v-col cols="2">
              <v-text-field
                v-model.number="loan.amount"
                label="Approved Loan Amount"
                :rules="[rules.number, rules.required, v => v <= studentPaymentPlan.plan_amount_balance || `Loan amount cannot exceed ₹${studentPaymentPlan.plan_amount_balance}`]"
                prefix="₹"
                dense
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-autocomplete
                v-model="loan.loan_provider"
                label="Loan Provider"
                :items="loanProviders"
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
                hide-details="auto"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" v-if="loan.loan_provider == 'Others'">
              <v-text-field
                v-model.trim="loan.load_provider_name"
                label="Provider Name"
                :rules="[rules.required]"
                dense
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="showLoanDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDate"
                    label="Transaction Date"
                    dense
                    readonly
                    suffix-icon="mdi-calendar"
                    outlined
                    v-bind="attrs"
                    hide-details="auto"
                    :value="formatToDDMMYYYY(loan.transaction_date)"
                    :rules="[rules.required]"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="loan.transaction_date"
                  :max="maxDate"
                  :min="minDate"
                  @input="showLoanDateMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="loan.loan_utr"
                label="UTR Number"
                :rules="[rules.required]"
                dense
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
      </div>
      <v-row
        v-if="studentPaymentPlan.plan_amount_balance <= 0"
        class="d-flex justify-center"
      >
        <v-card class="pa-3 text-center" elevation="0">
          <v-card-title class="primary--text"
            ><v-icon left class="primary--text"
              >mdi-checkbox-multiple-marked-circle</v-icon
            >Payment Successful</v-card-title
          >
        </v-card>
      </v-row>
      <v-card-actions
        class="d-flex justify-center mt-6"
        v-if="studentPaymentPlan.plan_amount_balance > 0"
      >
        <v-btn color="primary" :disabled="loan.amount > studentPaymentPlan.plan_amount_balance" @click="submit" :loading="loading">
          Complete Payment
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  name: "PaymentOptionsDialog",
  data() {
    return {
      rules,
      loading: false,
      studentPaymentPlan: {},
      form: {},
      applicantData: {},
      paymentData: {},
      loan: {
        loan_provider: "",
        loan_utr: "",
        amount: "",
        transaction_date: "",
        load_provider_name: "",
      },
      applicantId: null,
      types: [
        { name: "Term Fee", value: "term_fee" },
        { name: "Annual", value: "annual_upfront" },
        { name: "Full", value: "full_upfront" },
      ],
      payment_resolution_set: null,
      schedule: {},
      showLoanDateMenu: false,
      programName: "",
      current_program: null,
      showUTRFields: false,
      courseFee: [],
      valid: false,
      loanProviders: [
        { name: "ICICI Bank", value: "ICICI Bank" },
        { name: "HDFC Bank", value: "HDFC Bank" },
        { name: "SBI Bank", value: "SBI Bank" },
        { name: "City Union Bank", value: "City Union Bank" },
        { name: "Others", value: "Others" },
      ],
      changePlan: false,
      selectedPaymentOption: null,
      filteredPaymentOptions: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    minDate() {
      const twoDaysBack = new Date();
      twoDaysBack.setDate(twoDaysBack.getDate() - 2);
      return twoDaysBack.toISOString().substr(0, 10);
    },
    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },
    formattedDate() {
      if (!this.loan.transaction_date) return "";
      const [year, month, day] = this.loan.transaction_date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  watch: {},
  created() {
    this.setBreadcrumbs();
    this.initializeComponent();
  },
  methods: {
    async changeUpdatedPlan() {
      if (this.selectedPaymentOption === null) {
        this.$store.commit("showSnackbar", {
          message: "Please select the payment option to proceed",
          color: "error",
        });
        return;
      }
      this.loading = true;
      this.studentPaymentPlan.option_selected = this.selectedPaymentOption;
      this.studentPaymentPlan.changed_by = this.currentUser.email;
      await this.$axios.put(
        `/student_admit_plans/${this.studentPaymentPlan.id}`,
        {
          student_admit_plan: this.studentPaymentPlan,
        }
      );
      this.initializeComponent();
      this.loading = false;
    },
    changePaymentOption(option) {
      this.selectedPaymentOption = option;
    },
    formatAmount(value) {
      if (!value) return "0";
      return new Intl.NumberFormat("en-IN").format(value);
    },
    async initializeComponent() {
      this.applicantId = this.$route.query.id;
      if (this.applicantId) {
        await this.getApplicantDetails(this.applicantId);
        await this.resetFields();
        this.loan.amount = this.studentPaymentPlan.plan_amount_balance;
      }
    },
    resetFields() {
      this.$refs.form.reset();
    },
    setBreadcrumbs() {
      this.$store.commit("setBreadcrumbs", [
        { text: "Set Payment Options", to: { name: "Set Payment Options" } },
        { text: "Loan UTR Entry" },
      ]);
    },
    async getApplicantDetails(id) {
      try {
        const applicant_response = await this.$axios.get(
          `/applicant_details/${id}`
        );
        this.applicantData = applicant_response.data.data;

        const { program_id, application_id } = this.applicantData;
        const [programResult, batchResult, studentPlan] = await Promise.all([
          this.getProgram(program_id),
          this.getBatchSchedule(),
          this.$axios.get(
            `/student_admit_plans/?application_id=${application_id}`
          ),
        ]);
        this.studentPaymentPlan = studentPlan.data.data[0];
        this.studentPaymentPlan.name =
          this.studentPaymentPlan.plan_selected == "Term Fee"
            ? this.studentPaymentPlan.plan_selected
            : this.studentPaymentPlan.plan_selected + " Upfront";
        this.loan.amount = this.studentPaymentPlan.plan_amount_balance;
        await this.$axios
          .get(
            `/student_admit_plan_payments?student_admit_plan_id=${this.studentPaymentPlan.id}`
          )
          .then((res) => {
            const alreadyPaidPlans = res.data.data;
            const bankPlan = alreadyPaidPlans.find(
              (plan) => plan.paid_by === "BANK"
            );

            this.changePlan = !!bankPlan;

            // if (bankPlan) {
            //   this.loan = {
            //     ...bankPlan,
            //     amount: bankPlan.payment_amount,
            //     transaction_date: bankPlan.payment_date,
            //   };
            // }
          });
      } catch (error) {
        console.error("Error fetching applicant details:", error);
      }
    },
    async submit() {
      this.loading = true;
      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }
      const data = {
        student_admit_plan_id: this.studentPaymentPlan.id,
        mode: "Partner",
        payment_date: this.loan.transaction_date,
        payment_amount: this.loan.amount,
        paid_by: "BANK",
        transaction_id: null,
        loan_utr: this.loan.loan_utr,
        loan_provider:
          this.loan.loan_provider === "Others"
            ? this.loan.load_provider_name
            : this.loan.loan_provider,
        created_by: this.currentUser.email,
        order_id: null,
        bank_status: "Transaction Successful",
      };
      try {
        await this.$axios.post("/student_admit_plan_payments", {
          student_admit_plan_payment: data,
        });
        await this.initializeComponent();
      } catch (error) {
        console.error("Error submitting payment:", error);
      } finally {
        this.loading = false;
      }
    },

    formatToDDMMYYYY(date) {
      if (!date) return "";
      const [yrs, mon, day] = date.split("-");
      return `${day}-${mon}-${yrs}`;
    },
    parseFromDDMMYYYY(date) {
      const [day, mon, yrs] = date.split("-");
      return `${yrs}-${mon}-${day}`;
    },
    async getProgram(id) {
      try {
        const res = await this.$axios.get(`programs/${id}`);
        const program = res.data.data;
        this.programName =
          program.degree.short_name +
          (program.specialization ? " - " + program.specialization : "");
      } catch (error) {
        console.error("Error fetching program:", error);
      }
    },
    async getBatchSchedule() {
      try {
        const response = await this.$axios.get(
          `/batch_partner_schedules/${this.applicantData?.batch_partner_schedule_id}`
        );
        this.schedule = response.data.data;
      } catch (error) {
        console.error("Error fetching batch schedule:", error);
      }
    },
  },
};
</script>
